import { useToast } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { constructQueryParamsString, showErrorToast } from "../../../utils";
import { useGetQuestionsOfAudit } from "../../../hooks/query";
import LocalSpinner from "../../../components/LocalSpinner";
import React from "react";
import DataInputPanel from "../IssbDataInput/DataInputPanel";

const AuditRequirementList = () => {
  const toast = useToast();

  const roundSelector = useSelector((state) => state.issbRound);

  const questionnaireId = roundSelector?.selectedRound?.id;

  const getQueryParamsString = () => {
    const queryParams = {
      questionnaireId,
    };
    return constructQueryParamsString(queryParams);
  };

  // Fetch the questions
  const {
    /** {data:Question[]} */
    data: fullQuestionList = [],
    isLoading: isFetchingQuestions,
  } = useGetQuestionsOfAudit(
    getQueryParamsString(),
    {
      // react-query config
      onError: (err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
      cacheTime: 0, // disable caching -- because editing a question can affect what is shown here (and we have lots of places that make edits and in different ways)
      staleTime: 0, // disable caching
      // TODO useQuery cache + cache invalidation via query-keys
      // TODO caching - but where we can update a question if it is edited
    } // ./end react-query config
  );

  if (isFetchingQuestions) return <LocalSpinner />;

  console.log("fullQuestionList", fullQuestionList);

  return <DataInputPanel fullQuestionList={fullQuestionList} defaultGroupBy="stage" bulkActions={["RunDisclosure"]} />;
};
export default AuditRequirementList;
